/**
 * The System Options access permission as a boolean, for hiding (not disabling)
 * the profile-menu item and guarding the tab. The check is the shared access
 * evaluator (System Admin and folder grants included); the server enforces the
 * same registry permission on the handler routes.
 */
import { declarations } from '@ic/security-registry';
import { useCanAccess } from '@/hooks/useCanAccess';

export const SYSTEM_OPTIONS_PERMISSION = declarations.Maintenance.systemOptions.permission;

export function useSystemOptionsPermission(): boolean {
  const { canAccess } = useCanAccess();
  return canAccess(SYSTEM_OPTIONS_PERMISSION);
}
